import { useCallback } from "react";
import { useAppDispatch, useAppSelector } from "../../../redux/store";
import {
  getAllAnnouncements,
  getAnnouncementById,
  createAnnouncement,
  updateAnnouncement,
  deleteAnnouncement
} from "../../../redux/Actions/AnnouncementAction";
import { clearSelected, clearErrorState, setPage, setLimit } from "../../../redux/Slices/AnnouncementSlice";
import { AnnouncementFilters, CreateAnnouncementData, UpdateAnnouncementData } from "../../shared/model/AnnouncementInterfaces";

export const useAnnouncement = () => {
  const dispatch = useAppDispatch();
  const {
    announcements,
    selectedAnnouncement,
    loading,
    error,
    totalCount,
    hasNextPage,
    currentPage,
    currentLimit
  } = useAppSelector((state) => state.announcement);

  const fetchAnnouncements = useCallback(async (filters: AnnouncementFilters) => {
    await dispatch(getAllAnnouncements(filters));
  }, [dispatch]);

  const fetchAnnouncementById = useCallback(async (id: string) => {
    await dispatch(getAnnouncementById(id));
  }, [dispatch]);

  const createNewAnnouncement = useCallback(async (data: CreateAnnouncementData) => {
    return await dispatch(createAnnouncement(data));
  }, [dispatch]);

  const updateExistingAnnouncement = useCallback(async (id: string, data: UpdateAnnouncementData) => {
    return await dispatch(updateAnnouncement({ id, data }));
  }, [dispatch]);

  const deleteExistingAnnouncement = useCallback(async (id: string) => {
    return await dispatch(deleteAnnouncement(id));
  }, [dispatch]);

  const clearSelectedAnnouncement = useCallback(() => {
    dispatch(clearSelected());
  }, [dispatch]);

  const clearError = useCallback(() => {
    dispatch(clearErrorState());
  }, [dispatch]);

  const setCurrentPage = useCallback((page: number) => {
    dispatch(setPage(page));
  }, [dispatch]);

  const setCurrentLimit = useCallback((limit: number) => {
    dispatch(setLimit(limit));
  }, [dispatch]);

  return {
    announcements,
    selectedAnnouncement,
    loading,
    error,
    totalCount,
    hasNextPage,
    currentPage,
    currentLimit,
    fetchAnnouncements,
    fetchAnnouncementById,
    createNewAnnouncement,
    updateExistingAnnouncement,
    deleteExistingAnnouncement,
    clearSelected: clearSelectedAnnouncement,
    clearErrorState: clearError,
    setPage: setCurrentPage,
    setLimit: setCurrentLimit
  };
};
